import { render, staticRenderFns } from "./PendingVendor.vue?vue&type=template&id=c3b5b5d8&scoped=true&"
import script from "./PendingVendor.vue?vue&type=script&lang=js&"
export * from "./PendingVendor.vue?vue&type=script&lang=js&"
import style0 from "./PendingVendor.vue?vue&type=style&index=0&id=c3b5b5d8&prod&lang=scss&scoped=true&"
import style1 from "./PendingVendor.vue?vue&type=style&index=1&id=c3b5b5d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b5b5d8",
  null
  
)

export default component.exports